import { render, staticRenderFns } from "./builder-v3-steps.vue?vue&type=template&id=82434aea&scoped=true"
import script from "./builder-v3-steps.vue?vue&type=script&lang=ts"
export * from "./builder-v3-steps.vue?vue&type=script&lang=ts"
import style0 from "./builder-v3-steps.vue?vue&type=style&index=0&id=82434aea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82434aea",
  null
  
)

export default component.exports